import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Wave from '@/components/global/Wave.vue'
import SuccessDialog from '@/components/global/SuccessDialog.vue'
import BasicDialog from '@/components/global/BasicDialog.vue'
import axios from 'axios'
import VueMeta from 'vue-meta'
import JwtDecode from 'jwt-decode'
import VueAnalytics from 'vue-analytics'

const jwt = require('jsonwebtoken')

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const token = jwt.sign({}, process.env.VUE_APP_JWT_KEY, { expiresIn: '168h' })

axios.defaults.headers.common.secret = 'Bearer ' + token

if (localStorage.tradanaToken) {
  const token = localStorage.tradanaToken
  const decodedToken = JwtDecode(token)
  if (decodedToken.exp * 1000 < Date.now()) {
    localStorage.removeItem('tradanaToken')
  } else if (decodedToken.userId === null) {
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
  } else {
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    store.dispatch('setLoggedIn')
  }
}

if (localStorage.sid) {
  axios.defaults.headers.common.sid = localStorage.sid
}

Vue.component('tradana-wave', Wave)
Vue.component('success-dialog', SuccessDialog)
Vue.component('basic-dialog', BasicDialog)

Vue.use(VueMeta)

// Analytics
if (document.cookie.indexOf('unvergessenCookies=all') > -1) {
  Vue.use(VueAnalytics, {
    id: 'UA-173171010-3',
    router,
    debug: {
      sendHitTask: process.env.NODE_ENV === 'production'
    }
  })
} else {
  Vue.use(VueAnalytics, {
    id: 'UA-173171010-3',
    router,
    // disabled: true,
    disabled: process.env.VUE_APP_MODE === 'sandbox',
    debug: {
      sendHitTask: process.env.NODE_ENV === 'production'
    }
  })
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
